import "../../css/UniverseEffect.css"

const UniverseEffect = () => {
    return (<>
        {/* <div className="firework" id="firework"> */}
            <div className="explosion"></div>
            <div className="explosion"></div>
            <div className="explosion"></div>
            <div className="explosion"></div>
            <div className="explosion"></div>
            <div className="explosion"></div>
            <div className="explosion"></div>
            <div className="explosion"></div>
            <div className="explosion"></div>
            <div className="explosion"></div>
            <div className="explosion"></div>
            <div className="explosion"></div>
        {/* </div> */}
    </>)
}

export default UniverseEffect;